import { useQuery } from '@tanstack/react-query';
import { fetchYieldData } from './api';
import { FIELD_YIELD_DATA_QUERY_KEY } from '../../constants';

export const getFieldYieldDataQueryOptions = (fieldUuid: string, cropId: string) => {
  return {
    queryKey: [FIELD_YIELD_DATA_QUERY_KEY, fieldUuid, cropId],
    queryFn: () => fetchYieldData(fieldUuid, cropId),
    staleTime: Infinity,
    cacheTime: Infinity,
  };
};

export const useFieldYieldData = (fieldUuid: string, cropId: string) => {
  const { data: yieldData, isLoading, error } = useQuery(getFieldYieldDataQueryOptions(fieldUuid, cropId));

  return { yieldData, isLoading, error };
};
